import trackerSend from './helper'

const setDataToString = (extraData = {}) => {
  const data = {}
  Object.keys(extraData).forEach(k => {
    if (typeof extraData[k] === 'object') {
      data[k] = JSON.stringify(extraData[k])
    } else if (typeof extraData[k] !== 'undefined') {
      data[k] = `${extraData[k]}`
    }
  })
  return data
}

const round = number => Math.round(number * 1000) / 1000

class Tracker {
  constructor(pageName) {
    this.pageName = pageName
  }

  getElapsedTime = () =>
    this.initialLoadTime && round((new Date().getTime() - this.initialLoadTime) / 1000)

  pageLoadEvt = pageName => {
    if (pageName) {
      this.pageName = pageName
    }
    this.initialLoadTime = new Date().getTime()
    // TODO: send page_view event
  }

  // Only string values are allowed
  viewMessageEvt = (eventName, eventPayload) => {
    trackerSend(
      eventName,
      setDataToString({ ...eventPayload, accounts_elapsed_time: this.getElapsedTime() })
    )
  }
}

export default Tracker
